var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTicketLineM = function SvgTicketLineM(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 32,
    viewBox: "0 0 354 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ticket-line-m_svg__clip0_1449_5658)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 354,
    transform: "matrix(0 1 -1 0 354 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 16,
    r: 16,
    transform: "rotate(90 354 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 16,
    r: 3,
    transform: "rotate(90 329 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313,
    cy: 16,
    r: 3,
    transform: "rotate(90 313 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 16,
    r: 3,
    transform: "rotate(90 297 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 16,
    r: 3,
    transform: "rotate(90 281 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 16,
    r: 3,
    transform: "rotate(90 265 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 16,
    r: 3,
    transform: "rotate(90 249 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233,
    cy: 16,
    r: 3,
    transform: "rotate(90 233 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 16,
    r: 3,
    transform: "rotate(90 217 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 16,
    r: 3,
    transform: "rotate(90 201 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 16,
    r: 3,
    transform: "rotate(90 185 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 16,
    r: 3,
    transform: "rotate(90 169 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 16,
    r: 3,
    transform: "rotate(90 153 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 16,
    r: 3,
    transform: "rotate(90 137 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 16,
    r: 3,
    transform: "rotate(90 121 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 16,
    r: 3,
    transform: "rotate(90 105 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 16,
    r: 3,
    transform: "rotate(90 89 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 16,
    r: 3,
    transform: "rotate(90 73 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 16,
    r: 3,
    transform: "rotate(90 57 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 16,
    r: 3,
    transform: "rotate(90 41 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 16,
    r: 3,
    transform: "rotate(90 25 16)",
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 16,
    r: 16,
    transform: "rotate(90 0 16)",
    fill: "#F4EADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ticket-line-m_svg__clip0_1449_5658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 354,
    fill: "white",
    transform: "matrix(0 1 -1 0 354 0)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTicketLineM);
export default ForwardRef;